// extracted by mini-css-extract-plugin
module.exports = {"content__desktop__only":"styles_content__desktop__only__BiG7p","skeleton-animation":"styles_skeleton-animation__Esak0"};